// extracted by mini-css-extract-plugin
export default {"playbooksPageContainer":"playbook_page_playbooksPageContainer__N-21Y"};